<template>

  <div>
    <div class="home">

      <el-row>
        <el-col :span="24">
          <div>
            <el-input
                v-model="currentInput"
                type="textarea"
                placeholder="请输入原文..."
                :autosize="{ minRows: 5, maxRows: 8 }"
                resize="none"
                input-style="font-size: 24px"
            />
          </div>
        </el-col>
        <el-col :span="24" style="margin: 20px 0">
          <el-select
              v-model="targetLanguage"
              placeholder="Select"
              size="default"
              style="width: 100px; margin-right: 10px"
          >
            <el-option
                v-for="item in options"
                :key="item"
                :label="item"
                :value="item"
            />
          </el-select>
          <el-button color="#333333" style="width: 100px; margin-left: 10px" type="primary" :icon="Sort"
                     @click="sendMsg">翻译
          </el-button>
        </el-col>
        <el-col :span="24">
          <el-input
              v-model="result"
              type="textarea"
              readonly
              :autosize="{ minRows: 5, maxRows: 8 }"
              resize="none"
              input-style="font-size: 24px"
          />
        </el-col>
      </el-row>


    </div>
  </div>
</template>

<script>
// @ is an alias to /src


import {Sort} from "@element-plus/icons-vue";
import {createSocket, sendWSPush} from "@/api/websocket";
import {showErrorToast} from "@/api/common";

export default {
  name: 'HomeView',
  computed: {
    Sort() {
      return Sort
    },
  },
  components: {},
  data() {
    return {
      currentInput: '',
      result: '',
      targetLanguage: '中文',
      options: ['中文', '英文', '日语', '法语', '德语', '俄文', '西班牙文', '阿拉伯文'],
      answerId: '',
    }
  },
  created() {

    // 判断设备是否是移动端
    let flag = navigator.userAgent.match(
        /(phone|pad|pod|iPhone|iPod|ios|iPad|Android|Mobile|BlackBerry|IEMobile|MQQBrowser|JUC|Fennec|wOSBrowser|BrowserNG|WebOS|Symbian|Windows Phone)/i
    );
    if (flag) {
      console.log("移动端")
      this.initSocket();
    } else {
      this.$router.push("/"); // 跳转到新页面
    }
  },
  methods: {
    translate() {
      console.log(this.inputText)
    },
    initSocket() {
      var url = window.location.origin + '/vac-chat-api/stream/chat/chat';
      url = url.replace('http', 'ws');
      url = url.replace('8080', '8081');
      createSocket(url);
      const getSocketData = e => {  // 创建接收消息函数
        const data = e && e.detail.data
        console.log(data)
        if (data && data !== 'pong') {
          try {
            var dataStr = data;
            this.pushSocketMessage(JSON.parse(decodeURIComponent(dataStr)));
          } catch (e) {
            console.error(data)
            console.error(e)
          }
        }
      }
      window.addEventListener('onmessageWS', getSocketData)
    },
    pushSocketMessage(socketMsg) {
      if (!socketMsg.firstFlag && this.answerId && this.answerId !== socketMsg.answerId) {
        return true;
      }
      var content = socketMsg.content;
      if (!socketMsg.success) {
        showErrorToast("系统异常")
        return true;
      }

      this.result += content;
      console.log("this.result=", this.result)
      if (socketMsg.firstFlag) {
        this.answerId = socketMsg.answerId;
      }
      // 点击了停止按钮或者旧的对话
      if (socketMsg.answerId != this.answerId) {
        return false;
      }
      return true;
    },
    sendMsg() {
      this.result = '';
      console.log("sendMsg")
      if (this.currentInput.trim() === "") {
        return;
      }
      var msg = this.currentInput;
      var reqData = {
        content: msg.trim(),
        targetLanguage: this.targetLanguage,
        translateFrom: 'web',
        modelType: 'gpt-4o',
      };
      console.log(reqData)
      sendWSPush(reqData);
    },
  }
}
</script>

<style scoped>
.home {
  margin-left: auto;
  margin-right: auto;
}

</style>
